import { motion } from "framer-motion";

export const BatteryHydrogenTimeline = () => (
  <section data-testid="battery-hydrogen-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-0">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="lg:pr-12"
        >
          <h2
            data-testid="battery-hydrogen-headline"
            className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
          >
            Battery for speed. Hydrogen<br className="hidden lg:block" /> for duration
          </h2>
          <p data-testid="battery-hydrogen-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
            Battery and hydrogen serve complementary roles within one energy system.
            Batteries provide fast response and short-duration balancing, while hydrogen
            stores energy for longer periods.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          data-testid="battery-hydrogen-comparison"
          className="divide-y divide-borderLight lg:self-center lg:pl-12"
        >
          <div data-testid="battery-hydrogen-battery-info" className="py-6 first:pt-0 sm:py-7">
            <div className="flex flex-wrap items-baseline gap-x-3">
              <span className="font-heading text-base font-semibold uppercase tracking-[0.08em] text-ink">
                Battery
              </span>
              <span className="text-sm text-inkMuted">— Seconds &rarr; Hours</span>
            </div>
            <p className="mt-2 text-[15px] text-inkSoft">
              Fast response &middot; Short-duration balancing
            </p>
          </div>
          <div data-testid="battery-hydrogen-hydrogen-info" className="py-6 sm:py-7">
            <div className="flex flex-wrap items-baseline gap-x-3">
              <span className="font-heading text-base font-semibold uppercase tracking-[0.08em] text-ink">
                Hydrogen System
              </span>
              <span className="text-sm text-inkMuted">— Hours &rarr; Days</span>
            </div>
            <p className="mt-2 text-[15px] text-inkSoft">
              Long-duration storage &middot; Extended backup
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
